import { render, staticRenderFns } from "./TermAndCondGallery.vue?vue&type=template&id=0664385a&"
import script from "./TermAndCondGallery.vue?vue&type=script&lang=js&"
export * from "./TermAndCondGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports